import SubmitButton from "../../buttons";
import { LoginState, useLogin } from "../context";
import { LoadingSpinner } from "../../loading";
import { useState } from "react";
import { SelectInput } from "../../forms/SelectInput";

export const SelectAccount = () => {
  const { loginState} = useLogin();

  if (loginState == LoginState.SELECTACCOUNT) return <SelectYourAccount />;

  return <></>;
};

const SelectYourAccount = () => {
  const { submitting, error, accounts, selectAccount, setLoginError  } = useLogin();
  const [selectedAccount, setSelectedAccount] = useState("");

  let fullAccountsList = [{ text: "Select a role...", value: "" }];

  for (var i = 0; i < accounts.length; i++) {
    fullAccountsList.push({
      text: accounts[i].description,
      value: accounts[i].userId,
    });
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if(selectAccount.length == 0) {
          setLoginError("Select the role you want to access.")
        }
        else {
          setLoginError("")
          selectAccount(selectedAccount);
        }
      }}
    >
      <h1 className={"nhsuk-u-font-size-32"} style={{ marginBottom: "16px" }}>
        Select a role to access this service
      </h1>

      <p className={"nhsuk-u-font-size-19"}>
        You have multiple roles in this service. Select the role you want to use
        now.
      </p>
      <div style={{ maxWidth: "500px" }}>
        <SelectInput
          label="Role"
          onChange={(e: any) => {
            setSelectedAccount(e.target.value);
          }}
          width={"100%"}
          enabled={true}
          value={selectedAccount}
          options={fullAccountsList}
        />
      </div>
      {submitting && <LoadingSpinner />}
      {!submitting && (
        <SubmitButton content={<>Submit</>} style={{ marginLeft: 0 }} />
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}
    </form>
  );
};
